import React, { memo } from "react";
import { Stack, Box } from "@mui/material";

import { DecimalInput } from "../../../../components/DecimalInput";
import { Label, Row } from "../ProfitCalculator/index.styles";

import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import { selectProfitCalculator } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { toNumber } from "../../../../helpers/formatter";
import { TABLE_COLORS } from "../../../../constants";
import { updateLookupThunk } from "../../../../features/productAnalyzer/productAnalyzer.thunk";

const AdditionalExpense: React.FC = () => {
  const dispatch = useAppDispatch();
  const { profitCalculator } = useAppSelector(selectProfitCalculator);

  const handleInboundShippingChange = (inboundShipping: number) => {
    dispatch(updateLookupThunk({ inboundShipping }));
  };

  const handlePrepFeeChange = (prepFee: number) => {
    dispatch(updateLookupThunk({ prepFee }));
  };

  const handleMiscFeeChange = (miscFee: number) => {
    dispatch(updateLookupThunk({ miscFee }));
  };

  const handleMiscFeePercentChange = (miscFeePercent: number) => {
    dispatch(updateLookupThunk({ miscFeePercent }));
  };

  return (
    <Stack>
      <Row>
        <Label>Inbound Shipping</Label>
        <Box>
          <DecimalInput
            prefix="$"
            value={profitCalculator.inboundShipping}
            onEditing={handleInboundShippingChange}
            size="md"
            align="right"
          />
        </Box>
      </Row>

      <Row sx={{ backgroundColor: TABLE_COLORS.secondaryBackground }}>
        <Label>Prep Fee</Label>
        <Box>
          <DecimalInput
            prefix="$"
            value={profitCalculator.prepFee}
            onEditing={handlePrepFeeChange}
            size="md"
            align="right"
          />
        </Box>
      </Row>

      <Row>
        <Label>Misc Fee</Label>
        <Box>
          <DecimalInput
            prefix="$"
            value={profitCalculator.miscFee}
            onEditing={handleMiscFeeChange}
            size="md"
            align="right"
          />
        </Box>
      </Row>

      <Row sx={{ backgroundColor: TABLE_COLORS.secondaryBackground }}>
        <Label>Misc Fee (% of cost)</Label>
        <Box>
          <DecimalInput
            suffix="%"
            value={profitCalculator.miscFeePercent}
            onEditing={handleMiscFeePercentChange}
            size="md"
            align="left"
          />
        </Box>
      </Row>
    </Stack>
  );
};

export default memo(AdditionalExpense);
